import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-voting-finish',
  templateUrl: `${environment.pageFolder}/voting-finish.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/voting-finish.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: []
})

export class VotingFinishComponent {
  constructor(private router: Router) { }

  ngOnInit(): void {
    const loader = document.getElementById("loader-container")
    loader!.style.display = "none";
    if(sessionStorage.getItem("votingDone9") !== "true") {
      this.router.navigate(['/izbori']);
    } else {
      sessionStorage.removeItem("votingDone9");
    }
  }

  returnToVotingPage() {
    this.router.navigate(['/izbori']);
  }
}
